import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=098030ca&"
import script from "./Period.vue?vue&type=script&lang=js&"
export * from "./Period.vue?vue&type=script&lang=js&"
import style0 from "./Period.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports